import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";

import Animation from "@areas/shared/components/chooseLayout/Animation";
import animationStyles from "@areas/shared/components/chooseLayout/styles/animations.module.css";
import Honeycombs from "@areas/shared/components/background/Honeycombs";
import TextFilter from "@areas/shared/components/text/TextFilter";

import { metaActions } from "@store";

import Docs from "../home/blocks/Docs";
import RepublicCompanies from "../home/blocks/RepublicCompanies";
import ProfessionsAccordion from "./ProfessionsAccordion";
import SalaryLinks from "./SalaryLinks";
import UsefulInfoNews from "./UsefulInfoNews";
import JobMarketPages from "./JobMarketPages";
import styles from "./styles/jobMarket.module.css";

const TABS = {
  overview: {
    id: "overview",
    title: "Рынок труда",
    content: (
      <div className={styles.republicCompaniesSection}>
        <RepublicCompanies />
      </div>
    ),
    bare: true,
  },
  salaries: {
    id: "salaries",
    title: "Уровень заработных плат",
    content: <SalaryLinks />,
  },
  professions: {
    id: "professions",
    title: "Востребованные профессии",
    content: <ProfessionsAccordion />,
  },
  info: {
    id: "info",
    title: "Полезная информация",
    content: (
      <>
        
        <div className={styles.infoCardsSection}>
          <JobMarketPages />
        </div>
        <Docs /> 
        <UsefulInfoNews />
      </>
    ),
    
  },
};

const CELLS = [
  {
    key: "overview",
    position: "top",
    label: "Рынок труда",
    tab: "overview",
  },
  {
    key: "salaries",
    position: "right",
    label: "Уровень заработных плат",
    tab: "salaries",
  },
  {
    key: "info",
    position: "bottom",
    label: "Полезная информация",
    tab: "info",
  },
  {
    key: "professions",
    position: "left",
    label: "Востребованные профессии",
    tab: "professions",
  },
];

function Page() {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("overview");
  const panelRef = useRef(null);

  useEffect(() => {
    dispatch(
      metaActions.setData({
        icon: "/faviconSchoolboy.ico",
        title: "Рынок труда",
        description:
          "Востребованные профессии, уровень заработных плат и полезная информация о рынке труда Республики Башкортостан",
      })
    );
  }, [dispatch]);

  useEffect(() => {
    if (activeTab && panelRef.current) {
      panelRef.current.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  }, [activeTab]);

  const handleCellClick = (tabId) => {
    setActiveTab((prev) => (prev === tabId ? null : tabId));
  };

  const activeContent = activeTab ? TABS[activeTab] : null;

  return (
    <div className={styles.page}>
      <Animation
        animationIn={animationStyles.swipeLeftIn}
        animationOut={animationStyles.swipeRightOut}
      >
        <div className={styles.hero}>
          <Honeycombs style={styles.background} filter="#6E9A10" />
          <div className={`container ${styles.heroContent}`}>
            <TextFilter
              customStyles={{
                all: styles.pageTitle,
                text: styles.pageTitleText,
                filter: styles.pageTitleFilter,
              }}
            >
              Рынок труда
            </TextFilter>
            <p className={styles.subtitle}>
              Выберите раздел в сотах, чтобы узнать о востребованных профессиях,
              зарплатах и полезных ресурсах для планирования карьеры
            </p>

            <div className={styles.honeycomb} aria-label="Разделы рынка труда">
              {CELLS.map((cell) => {
                const isActive = activeTab === cell.tab;
                const isOverview = cell.tab === "overview";

                return (
                  <button
                    key={cell.key}
                    type="button"
                    className={`${styles.cell} ${styles[cell.position]} ${
                      isOverview ? styles.cellTitle : ""
                    } ${isActive ? styles.cellActive : ""}`}
                    onClick={() => handleCellClick(cell.tab)}
                    aria-pressed={isActive}
                    aria-controls="job-market-panel"
                  >
                    <span className={styles.cellLabel}>{cell.label}</span>
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      </Animation>

      {activeContent ? (
        <Animation>
          {activeContent.bare ? (
            <div
              id="job-market-panel"
              ref={panelRef}
              className={styles.panelBare}
              role="region"
              aria-label={activeContent.title}
            >
              {activeContent.content}
            </div>
          ) : (
            <div
              id="job-market-panel"
              ref={panelRef}
              className={`container ${styles.panel}`}
              role="region"
              aria-label={activeContent.title}
            >
              <div className={styles.panelInner}>
                <h2 className={styles.panelTitle}>{activeContent.title}</h2>
                <div className={styles.panelBody}>{activeContent.content}</div>
              </div>
            </div>
          )}
          {activeContent.footer ? (
            <div className={styles.panelFooter}>{activeContent.footer}</div>
          ) : null}
        </Animation>
      ) : null}
    </div>
  );
}

export default Page;
